import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Store, MessageCircle, User, LogIn } from 'lucide-react';
import { useAuthStore } from '@/store';
import { useState, useEffect } from 'react';

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuthStore();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) return;
    const fetch = async () => {
      try {
        const { apiClient } = await import('@/lib/api-client');
        const res = await apiClient.get<any>('/messages/unread-count');
        setUnreadCount(res.data?.count ?? 0);
      } catch {}
    };
    fetch();
    const id = setInterval(fetch, 60000);
    return () => clearInterval(id);
  }, [isAuthenticated]);

  const active = (path: string) =>
    pathname === path || (path !== '/' && pathname.startsWith(path));

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 flex items-stretch pb-safe">
      <NavItem to="/" icon={<Home />} label="Home" active={active('/')} />
      <NavItem to="/explore" icon={<Compass />} label="Explore" active={active('/explore')} />
      <NavItem to="/marketplace" icon={<Store />} label="Market" active={active('/marketplace')} />
      {isAuthenticated ? (
        <>
          <NavItem to="/messages" icon={<MessageCircle />} label="Messages" active={active('/messages')} badge={unreadCount} />
          <NavItem to="/dashboard" icon={<User />} label="Account" active={active('/dashboard')} />
        </>
      ) : (
        <>
          <NavItem to="/messages" icon={<MessageCircle />} label="Messages" active={active('/messages')} />
          <NavItem to="/login" icon={<LogIn />} label="Login" active={active('/login')} />
        </>
      )}
    </nav>
  );
}

function NavItem({
  to, icon, label, active, badge,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
  active: boolean;
  badge?: number;
}) {
  return (
    <Link
      to={to}
      className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-xs font-medium transition-colors ${
        active
          ? 'text-brand-600 dark:text-brand-400'
          : 'text-gray-500 dark:text-zinc-500'
      }`}
    >
      <span className="relative">
        <span className={`h-6 w-6 block [&>svg]:h-6 [&>svg]:w-6 ${active ? 'stroke-[2.5px]' : ''}`}>
          {icon}
        </span>
        {badge != null && badge > 0 && (
          <span className="absolute -top-1 -right-1.5 h-4 min-w-4 rounded-full bg-brand-600 text-white text-[9px] font-bold flex items-center justify-center px-0.5">
            {badge > 9 ? '9+' : badge}
          </span>
        )}
      </span>
      <span>{label}</span>
    </Link>
  );
}
